<div class="page-container">
  @if (showCampaignPicker()) {
    <form [formGroup]="campaignForm" class="campaign-form" data-testid="campaign-form">
      <formly-form [form]="campaignForm" [fields]="campaignFields" [model]="campaignModel" />
    </form>
  }

  <app-card>
    <app-card-header>
      <app-card-title>{{ 'myDay.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg">
          <app-spinner />
        </div>
      } @else {
        <div class="stats flex gap-md" data-testid="my-day-stats">
          <div class="stat flex flex-column flex-align-center">
            <span class="stat-value" data-testid="my-day-doors">{{ doors() }}</span>
            <span class="stat-label">{{ 'myDay.stats.doors' | translate }}</span>
          </div>
          <div class="stat flex flex-column flex-align-center">
            <span class="stat-value" data-testid="my-day-contacts">{{ contacts() }}</span>
            <span class="stat-label">{{ 'myDay.stats.contacts' | translate }}</span>
          </div>
          <div class="stat flex flex-column flex-align-center">
            <span class="stat-value" data-testid="my-day-leads">{{ leads() }}</span>
            <span class="stat-label">{{ 'myDay.stats.leads' | translate }}</span>
          </div>
        </div>

        @if (doors() > 0) {
          <div class="tally flex gap-xs mt-md" data-testid="my-day-tally">
            @for (kind of outcomeKinds; track kind) {
              @if (tally().get(kind); as n) {
                <span class="tally-item flex flex-align-center gap-xs">
                  <app-outcome-chip [outcome]="kind" /> <span class="tally-count">{{ n }}</span>
                </span>
              }
            }
          </div>
        }
      }
    </app-card-content>
  </app-card>

  @if (upcomingAppointments().length > 0) {
    <app-card class="mt-md">
      <app-card-header>
        <app-card-title>{{ 'myDay.upcomingAppointments.title' | translate }}</app-card-title>
      </app-card-header>
      <app-card-content>
        <ul class="item-list" data-testid="my-day-upcoming-appointments">
          @for (appt of upcomingAppointments(); track appt.id) {
            <li class="item-row">
              <a [routerLink]="['/leads', appt.lead_id]" class="item-link flex flex-justify-space-between flex-align-center gap-sm"
                [attr.data-testid]="'upcoming-appointment-' + appt.id">
                <span class="item-address">{{ 'interactions.form.appointment.type.' + appt.appointment_type | translate }}</span>
                <span class="item-meta"><app-icon name="calendar" [size]="14" /> {{ appt.scheduled_start | dateTimezone }}</span>
              </a>
            </li>
          }
        </ul>
      </app-card-content>
    </app-card>
  }

  @if (followUps().length > 0) {
    <app-card class="mt-md">
      <app-card-header>
        <app-card-title>{{ 'myDay.followUps' | translate }}</app-card-title>
      </app-card-header>
      <app-card-content>
        <ul class="item-list" data-testid="my-day-follow-ups">
          @for (i of followUps(); track i.id) {
            <li class="item-row">
              <a [routerLink]="['/map/addresses', i.address_id]" class="item-link flex flex-justify-space-between flex-align-center gap-sm"
                [attr.data-testid]="'follow-up-' + i.id">
                <span class="item-address">{{ addressLabel(i.address_id) }}</span>
                <span class="item-meta"><app-icon name="clock" [size]="14" /> {{ i.follow_up_at! | dateTimezone }}</span>
              </a>
            </li>
          }
        </ul>
      </app-card-content>
    </app-card>
  }

  <app-card class="mt-md">
    <app-card-header>
      <app-card-title>{{ 'myDay.activity' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      @if (!loading() && today().length === 0) {
        <div class="empty-state p-lg" data-testid="my-day-empty">
          <app-icon name="sunrise" [size]="40" />
          <p>{{ 'myDay.empty' | translate }}</p>
        </div>
      } @else {
        <ul class="item-list" data-testid="my-day-activity">
          @for (i of today(); track i.id) {
            <li class="item-row">
              <a [routerLink]="['/map/addresses', i.address_id]" class="item-link flex flex-justify-space-between flex-align-center gap-sm"
                [attr.data-testid]="'my-day-interaction-' + i.id">
                <span class="item-address">{{ addressLabel(i.address_id) }}</span>
                <span class="flex flex-align-center gap-xs">
                  <app-outcome-chip [outcome]="i.outcome_kind" [objectionId]="i.objection_id" />
                  <span class="item-meta">{{ i.occurred_at | relativeTime: now() }}</span>
                </span>
              </a>
            </li>
          }
        </ul>
      }
    </app-card-content>
  </app-card>
</div>
